import { env } from '@shared/utils/env';

export const TRANSFERS_ROUTE_PATHS = {
  transfers: '/treasury/transfers',
};

export const TRANSFERS_API_PATHS = {
  pixTransfer: '/v1/api/platform/treasury/transfers/pix',
  currencies: '/v1/api/common-services/all/currencies',
};

// ─────────────────────────────────────────────────────────────────────────────
// TODO: Replace this hardcoded map with a dynamic endpoint once one is available.
// The values below were ported directly from the Retool app (INF-765).
// Retool logic: account options depend on transfer type AND environment.
// prod vs staging accounts are different — do NOT swap them.
// When a proper API endpoint exists:
//   1. Remove ACCOUNT_OPTIONS_BY_TYPE entirely
//   2. Load from GET /v1/api/platform/treasury/accounts?type=<transferType>
//   3. Delete this comment block
// ─────────────────────────────────────────────────────────────────────────────
const isProd = env.MODE === 'production';

export const ACCOUNT_OPTIONS_BY_TYPE: Record<string, { value: string; label: string }[]> = {
  PIX: isProd
    ? [{ value: '1020', label: '1020' }]
    : [{ value: '1', label: '1 (staging)' }],
  BIND: isProd
    ? [
        { value: '920327', label: '1-749049/12' },
        { value: '939914', label: '1-749049/42' },
      ]
    : [
        { value: '12346291', label: '12346291 (Internal)' },
        { value: '12346292', label: '12346292 (External)' },
      ],
};

/** Transfer type options shown in the form dropdown. */
export const TRANSFER_TYPES = [
  { value: 'PIX', label: 'PIX' },
  { value: 'BIND', label: 'BIND' },
] as const;
